import { jsxs, jsx } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import { track } from "../../analytics/AnalyticsService.js";
import { AnalyticsTrackingEvent } from "../../analytics/events.js";
const MessageCardWrapper = styled("div")(() => ({
  boxSizing: "border-box",
  textAlign: "center",
  border: `1px solid #dcdddc`,
  borderRadius: 10,
  padding: "27px 40px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  backgroundColor: "#f6f8fa",
  gap: 10
}));
const MessageCardTitle = styled("div")(({ theme }) => ({
  fontSize: 20,
  fontWeight: 700,
  color: theme.vars.palette.text.primary,
  [theme.breakpoints.down("sm")]: {
    fontSize: 18
  }
}));
const MessageCardContent = styled("div")(({ theme }) => ({
  fontSize: 16,
  fontWeight: 500,
  color: theme.vars.palette.text.primary,
  textAlign: "center",
  [theme.breakpoints.down("sm")]: {
    fontSize: 14
  }
}));
const MessageActionButton = styled("button")(({ theme }) => ({
  marginTop: 10,
  height: 50,
  fontSize: 16,
  whiteSpace: "nowrap",
  padding: "0 20px",
  fontWeight: 600,
  borderRadius: "999px",
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  minWidth: 355,
  border: "none",
  cursor: "pointer",
  [theme.breakpoints.down("sm")]: {
    minWidth: "unset",
    height: 44,
    fontSize: 14
  }
}));
const MessageCard = ({
  title,
  content,
  cta,
  onActionClick,
  linkTo,
  trackedEventName,
  trackingParams,
  ...props
}) => {
  return /* @__PURE__ */ jsxs(MessageCardWrapper, { ...props, children: [
    /* @__PURE__ */ jsx(MessageCardTitle, { className: "store-message-card__title", children: title }),
    /* @__PURE__ */ jsx(MessageCardContent, { className: "store-message-card__content", children: content }),
    /* @__PURE__ */ jsx(
      MessageActionButton,
      {
        className: "store-message-card__cta",
        onClick: (e) => {
          track(trackedEventName || AnalyticsTrackingEvent.BUTTON_CLICK, {
            buttonName: cta,
            linkTo,
            ...trackingParams
          });
          onActionClick == null ? void 0 : onActionClick(e);
        },
        children: cta
      }
    )
  ] });
};
export {
  MessageCard as default
};
//# sourceMappingURL=MessageCard.js.map
